module.exports = __webpack_public_path__ + "static/media/viva_garden_01_A.5050a1e3.png";